import { isBigCompanyByUser } from "@/constants/vip";
import useAppStore from "@/context/store";
import { getBizOrderList, getHuabanTempCode } from "@/services";
import { gaodingEditHost, gaodingUmsHost } from "@/utils/host";
import { checkLogin, openWindow } from "@/utils/open";
import { PreCheckCode, showPreCheckMessage } from "./Message";

export const ERROR_MAP = {
  USER_IS_OLD_PERSONAL_ERROR: "12040009",
  GD_USER_IS_MERGE_ERROR: "12040010",
  HB_USER_IS_MERGE_ERROR: "12040011",
};

export const ORGS_CLASS_MAP = {
  PERSONAL: "personal",
  ORG: "org",
  KA: "ka",
};

export const TASK_STATUS = {
  pending: 0,
  success: 1,
  error: 2,
  rollback: 3,
};

export const gaodingEditUrl = `https://${gaodingEditHost}`;

export enum GdMergeStatus {
  /**初始化 */
  init,
  /**稿定账号已登录 */
  selectOrg,
  /**合并中 */
  merging,
  /**合并中间态: 登录了账号，但没点击合并 */
  interim,
  /** 冷启动选择创建个人还是团队 */
  coldBoot,
}

/**
 * 打开小窗进行稿定授权
 * @param needTelCode
 */
export async function goGaodingAuth(needTelCode) {
  const user = await checkLogin({
    source_location: "稿定授权登录",
  });

  // 关闭已有的授权窗口
  if (window.__gaoding_account_window) {
    window.__gaoding_account_window.close();
  }

  let code;
  //
  if (needTelCode) {
    // 临时code， 用于给稿定查询花瓣手机号用的
    const res = await getHuabanTempCode();
    code = res.code;
  }

  // 授权页面登录后，重定向至 /gdmerge/callbcak?code=xxxx页面
  // callback页面调用父窗口方法通知授权成功  window.opener.___gaoding_account_callback(authorization_code);
  window.__gaoding_account_window = openWindow({
    clientWidth: 770,
    clientHeight: 700,
    url:
      `https://${gaodingUmsHost}/ums/accredit?client_id=huaban&redirect_uri=${encodeURIComponent(
        "https://" + window.location.host + "/gdmerge/callback"
      )}&phone=${user.tel}` + (code ? `&code=${code}` : ""),
    windowName: "稿定账号授权",
  });
}

export const checkIsBigCompanyUser = (showMessage = true) => {
  const user = useAppStore.getState().user;
  if (isBigCompanyByUser(user)) {
    showMessage && showPreCheckMessage(PreCheckCode.bigCompany);
    return true;
  }
};

export const checkUnpayOrder = async (showMessage = true) => {
  const order = await getBizOrderList({
    status: 0,
  });

  if (order.list?.length > 0) {
    showMessage && showPreCheckMessage(PreCheckCode.unpayOrder);
    return true;
  }
};
